document.addEventListener("DOMContentLoaded", async function () {
  const overlay = document.getElementById("thinpad-overlay");
  let isProcessing = false;

  const PAD_CONFIG = {
    thinpad: {
      endpoint: "https://app.rugfashionstore.com/api/add-thin-pad",
      label: "Thin Pad",
      cartMatch: "thin pad rug",
    },
    deluxe: {
      endpoint: "https://app.rugfashionstore.com/api/add-deluxe-pad",
      label: "Deluxe Pad",
      cartMatch: "deluxe pad rug",
    },
  };

  // ── Check cart and disable already-added pad options ──
  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const cartTitles = cart.items.map((item) => item.title.toLowerCase());

    console.log("[Pad] Cart items:", cartTitles);

    document.querySelectorAll(".add-thin-pad").forEach(function (select) {
      const rugSize = select.dataset.size;

      Object.entries(PAD_CONFIG).forEach(([value, config]) => {
        const alreadyInCart = cartTitles.some(
          (title) => title.includes(config.cartMatch.toLowerCase()) && title.includes(rugSize.toLowerCase())
        );

        if (alreadyInCart) {
          const option = select.querySelector(`option[value="${value}"]`);
          if (option) {
            option.disabled = true;
            option.textContent = `${config.label} (already in cart)`;
          }
        }
      });
    });
  } catch (err) {
    console.warn("[Pad] Could not check cart:", err);
  }

  // ── Get pad variant from API with retries ──
  async function getPadVariant(endpoint, size, rugTitle, retries = 3) {
    for (let i = 1; i <= retries; i++) {
      try {
      //  console.log(`[Pad] Attempt ${i} | endpoint: ${endpoint}`);
     //   console.log(`[Pad] Sending: size="${size}", rug_title="${rugTitle}"`);

        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ size, rug_title: rugTitle }),
        });

      //  console.log(`[Pad] Response status: ${res.status}`);
        const text = await res.text();
      //  console.log(`[Pad] Response body:`, text);

        if (!res.ok) throw new Error(`API returned ${res.status}: ${text}`);
        if (!text) throw new Error("Empty response");

        const result = JSON.parse(text);
        if (result.success && result.variant_id) return result;

        console.warn(`[Pad] Attempt ${i}: success=${result.success}, variant_id=${result.variant_id}, full response:`, result);
      } catch (err) {
        console.error(`[Pad] Attempt ${i} error:`, err.message);
      }
      if (i < retries) await new Promise((r) => setTimeout(r, 2000));
    }
    return null;
  }

  // ── Add to Shopify cart with retry on 422 ──
  async function addToCart(variantId, retries = 2) {
    for (let i = 1; i <= retries; i++) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      const text = await res.text();

      if (res.ok) {
        const result = JSON.parse(text);
        if (result.title || result.product_title) return result;
        throw new Error("Cart item missing title");
      }

      if (res.status === 422 && i < retries) {
        console.warn(`[Pad] 422 on attempt ${i}, retrying in 2s...`);
        await new Promise((r) => setTimeout(r, 2000));
        continue;
      }

      console.error("[Pad] Shopify cart error:", res.status, text);
      throw new Error(`Cart add failed (${res.status}): ${text}`);
    }
  }

  // ── Select change handler ──
  document.querySelectorAll(".add-thin-pad").forEach(function (select) {
    select.addEventListener("change", async function () {
      const padType = this.value;
      const config = PAD_CONFIG[padType];

      console.log(`[Pad] Select changed: value="${padType}", dataset:`, JSON.stringify(this.dataset));

      if (!config || isProcessing) {
        console.log(`[Pad] Skipped: config=${!!config}, isProcessing=${isProcessing}`);
        return;
      }

      isProcessing = true;
      overlay.style.display = "flex";

      const size = this.dataset.size;
      const rugTitle = this.dataset.title;

      try {
        // Step 1: get variant ID from API
        const padData = await getPadVariant(config.endpoint, size, rugTitle);
        if (!padData) {
          alert(`Could not find a matching ${config.label}. Please try again.`);
          this.value = "";
          return;
        }

        // Step 2: add to Shopify cart
        const cartItem = await addToCart(padData.variant_id);
        console.log(`[Pad] ${config.label} added:`, cartItem.product_title, `$${padData.price}`);

        // Step 3: reload after confirmed
        location.reload();
      } catch (err) {
        console.error(`[Pad] Failed to add ${config.label}:`, err);
        alert(`Something went wrong adding the ${config.label}. Please try again.`);
        this.value = "";
      } finally {
        isProcessing = false;
        if (document.visibilityState === "visible") {
          overlay.style.display = "none";
        }
      }
    });
  });
});